module.exports = __webpack_public_path__ + "img/bg-brown.44a64d33.jpg";